const LEGACY_ANDROID_MAX_VERSION = 10;

export function shouldApplyLegacyAndroidSafeArea(userAgent: string): boolean {
  if (!userAgent || !/Android/i.test(userAgent)) {
    return false;
  }

  const match = userAgent.match(/Android\s+(\d+)(?:[._](\d+))?/i);
  if (!match) {
    return false;
  }

  const majorVersion = Number.parseInt(match[1] ?? '', 10);
  if (Number.isNaN(majorVersion)) {
    return false;
  }

  return majorVersion <= LEGACY_ANDROID_MAX_VERSION;
}
